import toggleOverlay from '../utils/toggleOverlay';
import { BREAKPOINTS } from 'scripts/utils/constants';

const initCollectionFilter = (): void => {
  const filterEl = document.querySelector<HTMLDivElement>('[data-filter]');
  const desktopMediaQuery: MediaQueryList = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  if (!filterEl) return;
  const filterTriggerEl = filterEl.querySelector<HTMLButtonElement>('[data-filter-trigger]');
  const filterForm = filterEl.querySelector<HTMLFormElement>('[data-filter-form]');
  const filterCloseEl = filterEl.querySelector<HTMLButtonElement>('[data-filter-close]');
  const filterResetBtn = filterEl.querySelector<HTMLButtonElement>('[data-filter-reset]');
  if (!filterTriggerEl || !filterForm || !filterCloseEl) return;
  const filterItemToggleEls = filterEl.querySelectorAll<HTMLButtonElement>('[data-filter-item-toggle]');
  const filterItemContentEls = filterEl.querySelectorAll<HTMLDivElement>('[data-filter-item-content]');

  const resetFilterUI = (): void => {
    toggleOverlay(false);
    filterForm.classList.remove('filter-open');
    filterForm.classList.add('-translate-x-full');
    filterTriggerEl.setAttribute('aria-expanded', String(false));
  };

  const resetFilterValues = (): void => {
    const { origin, pathname, search } = window.location;

    if (pathname.includes('/search')) {
      const params = new URLSearchParams(search);
      const q = String(params.get('q'));
      const newUrl = q?.length > 0 ? `${origin}${pathname}?q=${encodeURIComponent(q)}` : `${origin}${pathname}`;
      window.location.href = newUrl;
    } else {
      const cleanUrl = origin + pathname;
      window.location.href = cleanUrl;
    }
  };

  const toggleFilters = (): void => {
    const isOpen = filterForm.classList.toggle('filter-open');
    const overlayEl = toggleOverlay(isOpen);
    filterTriggerEl.setAttribute('aria-expanded', String(isOpen));
    filterForm.classList.toggle('-translate-x-full', !isOpen);

    if (isOpen) {
      filterCloseEl.addEventListener('click', toggleFilters);
      overlayEl?.addEventListener('click', toggleFilters);
    } else {
      filterCloseEl.removeEventListener('click', toggleFilters);
      overlayEl?.removeEventListener('click', toggleFilters);
    }
  };

  filterItemToggleEls.forEach((toggle): void => {
    toggle.addEventListener('click', (): void => {
      const filterContent = toggle.parentElement?.querySelector('[data-filter-item-content]');
      filterContent?.classList.toggle('lg:opacity-0');
      filterContent?.classList.toggle('lg:pointer-events-none');
    });
  });

  document.addEventListener('click', (e: MouseEvent): void => {
    const target = e.target as HTMLElement;

    filterItemContentEls.forEach((filterContent): void => {
      if (!filterContent.contains(target) && !(filterContent.previousElementSibling?.contains(target) ?? false)) {
        filterContent.classList.add('lg:opacity-0');
        filterContent.classList.add('lg:pointer-events-none');
      }
    });
  });


  filterTriggerEl.addEventListener('click', toggleFilters);
  filterResetBtn?.addEventListener('click', resetFilterValues);
  desktopMediaQuery.addEventListener('change', resetFilterUI);
};

export default initCollectionFilter;
